import React, { useContext, useMemo, useState } from 'react';
import UiSaveButtons from '../../../global/components/buttons/UiSaveButtons';
import FullPageWrapper from '../../../global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import _ from 'lodash';
import { useGolfers } from '../useHelpers/useGolfers';

const GolferChange = (props) => {

  const { golfer, handleCancel } = props
  const { firstName, lastName } = golfer ?? {}

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states } = golfParent_contexts ?? {}
  const { golfEvent_state, golfTournament_state } = states ?? {}
  const { golfers: golfers_event } = golfEvent_state ?? {}
  const { updating, _details, golfers: golfers_tournament } = golfTournament_state ?? {}

  const { handleChange_golferTournament } = useGolfers()

  const [selectedGolfer, setSelectedGolfer] = useState()

  const availableGolfers = useMemo(() => {
    const _availableGolfers = _.reject(_.cloneDeep(golfers_event), ge =>
      _.some(golfers_tournament, gt =>
        gt.id === ge.id
      )
    );
    return _.sortBy(_availableGolfers, 'lastName')
  }, [golfers_tournament, golfers_event])

  /** Saves the handicap to the database (event or tournament) */
  const handleChangeGolfer = () => {
    const newGolfer = golfers_event[checkedGolfer]
    handleChange_golferTournament({ existingGolferKey: golfer._itemKey, newGolfer, _details })
    handleCancel()
  }

  const handicapFooter = () => <UiSaveButtons
    save={{ oc: handleChangeGolfer, caption: selectedGolfer ? `Update Golfer (${selectedGolfer?.lastName}, ${selectedGolfer?.firstName})` : 'Update Golfer', disabled: !selectedGolfer }}
  />

  const ims_golfers = () => {
    const oc = (item) => { setSelectedGolfer(item) }
    return <ItemMenuSquares
      menuItems={availableGolfers}
      imsType={_imsTypes.inline}
      activeItem={selectedGolfer?.key}
      onClick={oc}
      css={'app-dark-mode'}
      style={{ padding: '1em' }}
      iconItem={'user'}
    />
  }

  const handicapWrapper = () => <Wrapper
    content={ims_golfers()}
    footer={handicapFooter()}
    wrapperType={wrapperTypes.paddedFooter}
  />

  const handicapContent = () => <FullPageWrapper
    content={handicapWrapper()}
    handleCancel={handleCancel}
    updating={updating}
    topperCaption={'Change Golfer'}
    topperCaption2={firstName + ' ' + lastName}
  />

  return handicapContent()
}

export default GolferChange